export const Mehsana = {
    title: "Mehsana",
    title1: "(Cultural & Agricultural Hub)",

    intro: "Mehsana is an important city located in the state of Gujarat, known for its rich agricultural practices, particularly in dairy farming. It serves as a key commercial center in the region, offering a blend of cultural heritage and modern development.",

    attractions: [
        {
            name: "Modhera Sun Temple",
            description: "The Modhera Sun Temple is one of the most famous heritage sites in Mehsana. Dedicated to the Sun God, this 11th-century temple is known for its stunning architecture and intricate carvings. The temple is designed in a way that the first rays of the sun illuminate the deity inside the temple on the equinoxes.",
            location: "Modhera, Mehsana, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "₹30 per person",
            bestTimeToVisit: "Early morning or late afternoon",
            activities: [
                "Explore the intricate carvings on temple walls",
                "Photography of the stunning architecture",
                "Visit the stepwell (Vav) in the temple complex",
                "Witness the sunrise on equinoxes",
                "Learn about the temple's history"
            ],
            mapLink: "https://maps.app.goo.gl/9gRfwvbuReFz2SHr7",
        },
        {
            name: "Brahmani Mata Temple",
            description: "The Brahmani Mata Temple is an ancient and revered site located near Mehsana. Dedicated to Goddess Brahmani, this temple is known for its spiritual significance and attracts devotees throughout the year, especially during festivals.",
            location: "Brahmani, Mehsana, Gujarat",
            timings: "6:00 AM to 7:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend aarti and prayer sessions",
                "Meditate in the temple’s peaceful atmosphere",
                "Participate in the temple’s religious festivals",
                "Explore the temple’s spiritual significance",
                "Engage with local devotees and learn about the temple's history"
            ],
            mapLink: "https://maps.app.goo.gl/ZtNGhtTzFvCoCgFdA",
        },
        {
            name: "Shanku's Water Park and Resort",
            description: "Shanku's Water Park and Resort is a popular recreational destination in Mehsana. Known for its wide variety of water slides, pools, and other attractions, it is a family-friendly destination perfect for a day of fun and relaxation.",
            location: "Shanku, Mehsana, Gujarat",
            timings: "10:00 AM to 6:00 PM",
            ticket: "₹500 per person",
            bestTimeToVisit: "April to October",
            activities: [
                "Enjoy water slides and rides",
                "Relax in the swimming pools",
                "Indulge in indoor and outdoor activities",
                "Spend quality time with family and friends",
                "Have fun in the wave pool"
            ],
            mapLink: "https://maps.app.goo.gl/nYhRPVh5D38nVje8A",
        },
        {
            name: "Tarna Temple",
            description: "Tarna Temple is a beautiful and historic temple dedicated to Goddess Tarna, offering a stunning view of Mehsana city from its hilltop location. It is a popular religious site for both locals and visitors.",
            location: "Tarna Hill, Mehsana, Gujarat",
            timings: "5:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Climb the hill for a breathtaking view",
                "Participate in the aarti and prayers",
                "Admire the architecture and peaceful surroundings",
                "Meditate at the temple",
                "Capture scenic views of the city"
            ],
            mapLink: "https://maps.app.goo.gl/GnXeQ2wT1gy8zBmd6",
        },
        {
            name: "Kadi Dam",
            description: "Kadi Dam is an important water reservoir located near Mehsana, known for its natural beauty and tranquility. The dam is surrounded by lush greenery and offers an excellent spot for picnics, nature walks, and boating.",
            location: "Kadi, Mehsana, Gujarat",
            timings: "Open throughout the day",
            ticket: "Free Entry",
            bestTimeToVisit: "November to March",
            activities: [
                "Picnic by the reservoir",
                "Photography of the dam and surroundings",
                "Go boating on the water",
                "Take a nature walk in the surrounding area",
                "Enjoy birdwatching"
            ],
            mapLink: "https://maps.app.goo.gl/7E5vWzVfpwD56UtH7",
        },
        {
            name: "Mehsana Dairy",
            description: "Mehsana is known for its dairy farming, and the Mehsana Dairy is an essential part of the city’s economy. It’s a great place to learn about Gujarat’s dairy industry, taste fresh dairy products, and understand the importance of the cooperative dairy movement in India.",
            location: "Mehsana, Gujarat",
            timings: "9:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Throughout the year",
            activities: [
                "Learn about dairy production",
                "Taste fresh milk products",
                "Explore the cooperative model of dairy farming",
                "Visit the dairy farm and interact with farmers",
                "Support local dairy products"
            ],
            mapLink: "https://maps.app.goo.gl/XyWyY7d6jA5Fd1Hj9",
        },
    ]
};
